import { Typography, Divider, Grid } from '@mui/material';
import React from 'react';
import {
  DateField,
  Edit as Show,
  Labeled,
  SimpleShowLayout,
  TextField,
  useTranslate,
} from 'react-admin';
import { QuickbooksPriceField } from '../components/QuickbooksPriceField';
import { TaxesArrayField } from '../contracts/TaxesArrayField';
import { QbLinesFields } from './QbLinesFields';

export const CreditMemoShow = () => {
  const translate = useTranslate();

  return (
    <Show>
      <Typography m={2} variant='h5'>
        {translate('resources.creditmemos.name', { smart_count: 1 })}
      </Typography>
      <Divider sx={{mx: 2, mb: 1}}/>
      <Grid container spacing={2} mt={-1}>
        <Grid item xs={12} mx={2}>
        <Labeled label="resources.creditmemos.fields.TxnDate">
          <DateField source="TxnDate" />
        </Labeled>
        <QbLinesFields />
        <br />
        <TaxesArrayField source="TxnTaxDetail.TaxLine" />
        <br />
        <Labeled label="resources.creditmemos.fields.TotalAmt">
          <QuickbooksPriceField source="TotalAmt" />
        </Labeled>
        </Grid>
        </Grid>
    </Show>
  );
};
